<template>
   <new-modal-wrapper
    :class="[
      'new-ugc-modal-wrapper',
      'new-ugc-modal-wrapper-step-' + activeViewComponent + '-wrapper',
    ]"
    modal-name="newUgcModal"
    modal-classes="new-ugc-modal"
    :headerTitle="$store.state.translations.data[titles[activeViewComponent]]"
    :headerImg="!!showHeaderImage[activeViewComponent]"
    :click-to-close="false"
    :isUGCModal="true"
    :showStepsView="!!showStepsView[activeViewComponent]"
    ref="newUgcModal"
    :cta-primary-button="ctaButtons[activeViewComponent]"
    :cta-primary-button-arguments="ctaButtonArguments[activeViewComponent]"
    :disable-buttons="$store.state.ugc.stateManager.isLoading"
    :disable-next-back-buttons="$store.state.ugc.stateManager.activeControl !== ''"
    :disable-close-button="$store.state.utils.errorModalProcess"
    @cta-action="ctaAction"
    @go-back="goBack"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    @close-action="close"
    :style="modalStyles"
  >
    <ugc-topbar
      ref="ugcTopBar"
      :hide="true"
      @disable-next-back-buttons="updateDisableNextBackButtons"
    ></ugc-topbar>
    <ugc-go-back-button
      ref="ugcBackButton"
      class="hide"
    ></ugc-go-back-button>
    <component
      ref="content"
      @showBackButton="showBackButton"
      @showIconButton="showIconButton"
      @showCtaButton="showCtaButton"
      :is="activeViewComponent"
      v-bind="componentAttributes[activeViewComponent]"
    ></component>
  </new-modal-wrapper>
</template>

<script>
import newModalWrapper from '@/components/Modals/NewModalWrapper/NewModalWrapper';
import ugcDesignView from '@/components/UGC/UGCMainComponents/DesignView';
import ugcAlmostDone from '@/components/UGC/UGCMainComponents/AlmostDone';
import ugcNewConfirmDesign from '@/components/UGC/UGCMainComponents/NewConfirmDesign';
import UgcConfirmDesignStep from '@/components/molecule.ugcConfirmDesignStep.vue';
import ugcTopbar from '@/components/UGC/TopBar';
import ugcGoBackButton from '@/components/UGC/GoBackButton';
import newUgcAlmostDone from '@/components/molecule.ugcAlmostDone.vue'

export default {
  name: "NewUgcModal",
  components: {
    newModalWrapper,
    ugcDesignView,
    ugcAlmostDone,
    newUgcAlmostDone,
    ugcNewConfirmDesign,
    UgcConfirmDesignStep,
    ugcTopbar,
    ugcGoBackButton,
  },
  data() {
    return {
      modalStyles: {
        'min-height': 'initial',
      },
      ctaButtons: {
        'ugc-design-view': 'ugc-next',
        'ugc-almost-done': null,
        'terms-conditions-form': 'add-your-image',
        'ugc-new-confirm-design': 'ugcTopBarFinish',
        'ugc-confirm-design-step': 'ugcTopBarFinish',
      },
      ctaButtonArguments: {
        'ugc-design-view': { action: 'next' },
        'ugc-almost-done': null,
        'new-ugc-almost-done': null,
        'terms-conditions-form': { action: 'next' },
        'ugc-new-confirm-design': { action: 'finish' },
        'ugc-confirm-design-step': { action: 'finish' },
      },
      titles: {
        'ugc-design-view': null,
        'ugc-almost-done': null,
        'new-ugc-almost-done': null,
        'terms-conditions-form': 'twoStepsTermsConditionModalHeaderTitle',
        'ugc-new-confirm-design': 'termsConditionsAddYourImage',
        'ugc-confirm-design-step': 'termsConditionsAddYourImage',
      },
      componentAttributes: {
        'ugc-design-view': {},
        'ugc-almost-done': {},
        'new-ugc-almost-done': { showStepsView: true },
        'terms-conditions-form': {},
        'ugc-new-confirm-design': { showStepsView: true },
        'ugc-confirm-design-step': { showStepsView: true },
      },
      showHeaderImage: {
        'ugc-design-view': false,
        'ugc-almost-done': false,
        'new-ugc-almost-done': false,
        'terms-conditions-form': false,
        'ugc-new-confirm-design': true,
        'ugc-confirm-design-step': true,
      },
      showStepsView: {
        'ugc-design-view': true,
        'ugc-almost-done': true,
        'new-ugc-almost-done': true,
        'terms-conditions-form': true,
        'ugc-new-confirm-design': false,
        'ugc-confirm-design-step': false,
      },
      disableNextBackButtons: false,
    }
  },
  computed: {
    activeUGCIndex() {
      return this.$store.state.ugc.tempData.activeUGCIndex;
    },
    activeViewComponent() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].activeUGCView;
    },
  },
  watch: {
    activeViewComponent() {
      this.adjustModalHeight();
    },
    activeUGCIndex(newVal) {
      this.checkShowBackButtonInFirstStep(newVal);
    },
    ['$store.state.ugc.stateManager.currentUgcView']: {
      handler: 'checkDisableBackButtonInFirstStep',
      immediate: true,
    },
  },
  methods: {
    showBackButton(value) {
      this.$refs.newUgcModal.showBackButton(value);
    },
    showIconButton(value) {
      this.$refs.newUgcModal.showIconButton(value);
    },
    showCtaButton(value) {
      this.$refs.newUgcModal.showCtaSecondaryButton(value);
    },
    beforeClose() {
      this.$store.commit("ugc/stateManager/SET_LOADING", false);
      this.$store.commit("ugc/tempData/SET_UPLOAD_ANOTHER", null);
      this.$store.commit("ugc/tempData/SET_SELECT_ANOTHER", null);
    },
    close() {
      this.$refs.ugcTopBar.exit();
    },
    beforeOpen() {
      const tempData = this.$store.state.ugc.tempData.features[this.activeUGCIndex];
      // TODO 2nd component flow steps fix will need handling of this ugc flow views
      if (this.activeUGCIndex !== 1 ||
      (this.activeUGCIndex === 1 && !tempData.selectAnother && !tempData.isReplaceTool)
      ) {
        this.$store.dispatch("ugc/CREATE_UGC_FLOW_VIEWS");
      }

      this.$eventBus.$emit("ugc-modal-open");
    },
    goBack() {
      this.$refs.ugcBackButton.goBack();
    },
    adjustModalHeight() {
      let height = window.innerHeight;
      const screenSize = this.$store.getters["utils/returnScreenSize"];
      if (this.$store.getters['utils/noEsiActive'] && this.$store.getters['utils/isIframeSameOrigin']
          &&  (screenSize.includes('mobile') || screenSize.includes('medium'))
        ) {
        // need to send a postMessage to get the inner height from parent.
        height = window.parent.innerHeight;
        this.modalStyles = {
          ...this.modalStyles,
          height: `${height}px`
        };
      } else {
        this.modalStyles = {
          ...this.modalStyles,
          maxHeight: `${height}px`,
        };
      }
    },
    ctaAction({ action }) {
      if (action === 'next') {
        this.$refs.ugcTopBar.checkPlacement();
      } else if (action === 'finish') {
        this.$refs.ugcTopBar.finish();
      } else if (this.$refs.content.ctaAction) {
        this.$refs.content.ctaAction();
      } else {
        this.$modal.hide('newUgcModal');
      }
    },
    checkDisableBackButtonInFirstStep() {
      if (this.$refs.newUgcModal && this.activeUGCIndex === 1) this.showBackButton(true);
      if (this.$refs.newUgcModal && this.activeUGCIndex !== 1) this.showBackButton(this.$store.state.ugc.stateManager.currentUgcView !== 0);
    },
    checkShowBackButtonInFirstStep(val) {
      if (!this.$refs.newUgcModal) return;
      if (val === 1) this.showBackButton(true);
      else this.showBackButton(false);
    },
    updateDisableNextBackButtons(disable) {
      this.disableNextBackButtons = disable;
    }
  },
  created() {
    window.addEventListener('resize', this.adjustModalHeight);
  },
  mounted() {
    this.adjustModalHeight();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.adjustModalHeight);
  },
};
</script>
